const urlParams = new URLSearchParams(window.location.search);

export type UTMParams = {
    utm_source?: string;
    utm_medium?: string;
    utm_campaign?: string;
    utm_term?: string;
    utm_content?: string;
    gclid?: string;
    fbclid?: string;
}

export const getUTMParameters = (): UTMParams => {
    if (window.sessionStorage.getItem('has_utm') === 'true') {
        return {
            utm_source: window.sessionStorage.getItem('utm_source') || '',
            utm_medium: window.sessionStorage.getItem('utm_medium') || '',
            utm_campaign: window.sessionStorage.getItem('utm_campaign') || '',
            utm_term: window.sessionStorage.getItem('utm_term') || '',
            utm_content: window.sessionStorage.getItem('utm_content') || '',
            gclid: window.sessionStorage.getItem('gclid') || '',
            fbclid: window.sessionStorage.getItem('fbclid') || '',
        };
    } else {
        return {
            utm_source: urlParams.get('utm_source') || '',
            utm_medium: urlParams.get('utm_medium') || '',
            utm_campaign: urlParams.get('utm_campaign') || '',
            utm_term: urlParams.get('utm_term') || '',
            utm_content: urlParams.get('utm_content') || '',
            gclid: urlParams.get('gclid') || '',
            fbclid: urlParams.get('fbclid') || urlParams.get('FBCLID') || '',
        };
    }
}

// Extend Window interface for dataLayer
declare global {
    interface Window {
        dataLayer: any[];
    }
}

// GA4 Event tracking utility
export const trackEvent = (eventName: string, parameters: Record<string, any>) => {
    console.log('GA4 Event:', eventName, parameters);
    if (typeof window !== 'undefined' && window.dataLayer) {
        window.dataLayer.push({
            event: eventName,
            ...parameters
        });
    }
}

export const getValueBand = (value: string | number) => {
    const num = typeof value === 'string' ? parseFloat(value) : value;
    if (isNaN(num)) return 'unknown';
    if (num < 100000) return 'under_100k';
    if (num < 150000) return '100k_150k';
    if (num < 250000) return '150k_250k';
    if (num < 400000) return '250k_400k';
    if (num < 600000) return '400k_600k';
    return '600k_plus';
};;